document.addEventListener('DOMContentLoaded', function () {
  const blocks = document.querySelectorAll('.variant-video-block');

  blocks.forEach(function (block) {
    const productId = block.dataset.productId;
    const region = (block.dataset.region || 'en').toLowerCase();
    const player = document.getElementById(`variant-video-player-${productId}`);
    const thumbs = document.getElementById(`variant-video-thumbs-${productId}`);
    if (!player) return;

    const variantItems = block.querySelectorAll('.variant-video-item');
    const variantMap = {};

    variantItems.forEach(function (item) {
      const variantId = item.dataset.variantId;
      const jsonEl = item.querySelector('.variant-video-json');
      if (!jsonEl) return;

      try {
        variantMap[String(variantId)] = JSON.parse(jsonEl.textContent);
      } catch (e) {
        variantMap[String(variantId)] = {};
      }
    });

    let fallbackMap = {};
    const fallbackJson = block.querySelector('.product-fallback-video-json');
    if (fallbackJson) {
      try {
        fallbackMap = JSON.parse(fallbackJson.textContent);
      } catch (e) {
        fallbackMap = {};
      }
    }

    function buildVideoHtml(video) {
      if (!video || !video.sources || !video.sources.length) return '';

      const posterAttr = video.poster ? ` poster="${video.poster}"` : '';
      const sourcesHtml = video.sources.map(function (source) {
        const typeAttr = source.type ? ` type="${source.type}"` : '';
        return `<source src="${source.url}"${typeAttr}>`;
      }).join('');

      return `
        <div class="variant-video-frame">
          <video class="product-variant-video" controls playsinline preload="metadata"${posterAttr}>
            ${sourcesHtml}
          </video>
        </div>
      `;
    }

    function buildThumbsHtml(videos) {
      if (!thumbs) return;
      if (!videos || !videos.length) {
        thumbs.innerHTML = '';
        return;
      }

      thumbs.innerHTML = videos.map(function (video, index) {
        const activeClass = index === 0 ? ' is-active' : '';
        const thumbInner = video.poster
          ? `<img src="${video.poster}" alt="Video preview">`
          : `Video ${index + 1}`;

        return `
          <button type="button" class="variant-video-thumb${activeClass}" data-video-index="${index}">
            ${thumbInner}
          </button>
        `;
      }).join('');

      thumbs.querySelectorAll('.variant-video-thumb').forEach(function (button) {
        button.addEventListener('click', function () {
          const index = Number(button.dataset.videoIndex || 0);
          const video = videos[index];
          player.innerHTML = buildVideoHtml(video);

          thumbs.querySelectorAll('.variant-video-thumb').forEach(function (btn) {
            btn.classList.remove('is-active');
          });
          button.classList.add('is-active');
        });
      });
    }

    function findProductForm() {
      const section = block.closest('.shopify-section');
      if (section) {
        const formInSection = section.querySelector('form[action*="/cart/add"]');
        if (formInSection) return formInSection;
      }
      return document.querySelector('form[action*="/cart/add"]');
    }

    function getCurrentVariantId() {
      const form = findProductForm();
      if (!form) return null;
      const input = form.querySelector('input[name="id"]');
      return input ? input.value : null;
    }

    function getVideosForVariant(variantId) {
      const variantData = variantMap[String(variantId)] || {};
      const regionVideos = variantData[region] || [];
      const fallbackRegionVideos = fallbackMap[region] || [];
      const fallbackEnVideos = fallbackMap.en || [];
      const variantEnVideos = variantData.en || [];

      if (regionVideos.length) return regionVideos;
      if (fallbackRegionVideos.length) return fallbackRegionVideos;
      if (region !== 'en' && variantEnVideos.length) return variantEnVideos;
      if (region !== 'en' && fallbackEnVideos.length) return fallbackEnVideos;
      return [];
    }

    function updateVideos() {
      const variantId = getCurrentVariantId();
      if (!variantId) return;

      const videos = getVideosForVariant(variantId);
      if (videos.length) {
        player.innerHTML = buildVideoHtml(videos[0]);
      } else {
        player.innerHTML = '';
      }
      buildThumbsHtml(videos);
    }

    updateVideos();

    document.addEventListener('change', function (event) {
      const target = event.target;
      if (!target) return;

      const isRelevant =
        target.name === 'id' ||
        target.closest('variant-selects') ||
        target.closest('variant-radios') ||
        target.closest('form[action*="/cart/add"]');

      if (isRelevant) {
        setTimeout(updateVideos, 120);
      }
    });
  });
});